var _path, _path2, _path3, _path4, _path5, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 360,
    viewBox: "0 0 364 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198 240H318V360H198V240Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237 123C237 108.413 231.205 94.4236 220.891 84.1091C210.576 73.7946 196.587 68 182 68C167.413 68 153.424 73.7946 143.109 84.1091C132.795 94.4236 127 108.413 127 123C127 137.587 132.795 151.576 143.109 161.891C153.424 172.205 167.413 178 182 178C196.587 178 210.576 172.205 220.891 161.891C231.205 151.576 237 137.587 237 123Z",
    fill: "#304FF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182 160C172.575 160 163.536 156.29 156.872 149.685C154.548 147.382 152.579 144.792 151 142H213C211.421 144.792 209.452 147.382 207.128 149.685C200.464 156.29 191.425 160 182 160Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82 250C82 219.072 107.072 194 138 194H226C256.928 194 282 219.072 282 250V324H82V250Z",
    fill: "#D1D1D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.11 240C281.695 243.245 282 246.587 282 250V324H198V240H281.11Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 278,
    width: 40,
    height: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 302,
    width: 40,
    height: 8,
    transform: "rotate(-90 236 302)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.7a0264a8ef9eb7e9e4b3863033a6fd8b.svg";
export { ForwardRef as ReactComponent };